<template>
  <v-container fluid v-if="document">
    <h1>{{document.title}}</h1>
    <div class="text">{{document.description}}</div>
  </v-container>
  <v-container fluid v-else>
    <v-list>
      <v-list-item v-for="doc in documents" :key="doc.id" ripple three-line>
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1">{{doc.title}}</v-list-item-title>
              <v-list-item-subtitle>{{doc.subtitle}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar tile size="80" color="grey"></v-list-item-avatar>
          </v-list-item>

          <v-card-actions>
            <v-btn text>meer info</v-btn>
          </v-card-actions>
        </v-card>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import data from "@/assets/content.json";
export default {
  metaInfo: {
    title: "Route"
  },
  data() {
    return {
      documents: data.routes,
      document: null
    };
  },
  computed: {
    data() {
      return this.documents;
    }
  },
  mounted() {
    this.getDoc();
  },
  watch: {
    $route() {
      this.getDoc();
    }
  },
  methods: {
    getDoc() {
      const docs = this.documents.filter(
        doc => doc.id === this.$route.params.id
      );
      if (docs.length > 0) this.document = docs[0];
    }
  }
};
</script>

<style>
</style>
